import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Collapse from 'components_new/atoms/Collapse'
import Icon from 'components_new/atoms/Icon'
import Switch from 'components_new/atoms/Switch'

import FormSection from 'components_new/molecules/FormSection'
import PreviewEmbeddedContent from 'components_new/molecules/PreviewEmbeddedContent'
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import SidebarDialog from 'components_new/molecules/SidebarDialog'

import { ParsedDashboardFilterOptions } from 'types/GlobalDashboardFilter'
import { TDashboardWidgetFullyLoaded } from 'types/GlobalWidget'

import { useTranslation } from 'language/translator'

const URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://portal.homepal.se'

interface EmbeddedDialogProps {
  dashboardFilterOptions: Map<string, ParsedDashboardFilterOptions>
  loading: boolean
  onClose: () => void
  onChange: (embeddable: boolean) => void
  open: boolean
  widget: TDashboardWidgetFullyLoaded
}

const EmbeddedDialog = (props: EmbeddedDialogProps) => {
  const { dashboardFilterOptions, onClose, onChange, open, widget } = props

  const { t } = useTranslation()

  const isPublic = widget.settings.embeddable
  const component = t('dashboards', 'widget', true)

  return (
    <SidebarDialog
      actions={
        <Button variant="text" onClick={onClose}>
          {t('global', 'close')}
        </Button>
      }
      open={open}
      onClose={onClose}
      title={t('global', 'embed') + ' ' + widget.settings.title}
      maxWidth="md"
    >
      <FormSection
        helperText={t(
          'dashboards',
          'enable_external_access_helper_text',
          false,
          { component }
        )}
        title={t('dashboards', 'enable_external_access')}
      >
        <SettingsGroup>
          <SettingsItem
            actions={
              <Switch
                color="success"
                checked={isPublic}
                onChange={() => onChange(!isPublic)}
                size="medium"
              />
            }
            body={t('dashboards', 'public_link_description')}
            icon={<Icon name={'PublicOutlined'} />}
            title={t('dashboards', 'public_link')}
          />
        </SettingsGroup>
      </FormSection>
      <Collapse in={isPublic}>
        <Box sx={{ flex: 1 }}>
          <FormSection
            helperText={t('dashboards', 'embed_link_helper_text', false, {
              component
            })}
            title={t('dashboards', 'embed_link_title')}
          >
            {isPublic ? (
              <PreviewEmbeddedContent
                availableFeatures={['filter', 'auto_refresh']}
                filterOptions={dashboardFilterOptions}
                link={`${URL}/public/widgets/${widget.id}`}
                title={widget.title}
                sx={{ mb: 4 }}
              />
            ) : null}
          </FormSection>
        </Box>
      </Collapse>
    </SidebarDialog>
  )
}

export default EmbeddedDialog
